document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-section-type="read-more-text"]')
    .forEach(section => {

      const wrapper = section.querySelector('.read-more-wrapper');
      const text = section.querySelector('.read-more-text');
      const button = section.querySelector('.read-more-toggle');

      if (!wrapper || !text || !button) return;

      // Zorg dat alles zichtbaar is om correct te meten
      text.style.maxHeight = 'none';

      const computed = window.getComputedStyle(text);
      const lineHeight = parseFloat(computed.lineHeight);

      if (!lineHeight) return;

      const collapsedHeight = lineHeight * 2;

      // Meet volledige hoogte
      const fullHeight = text.scrollHeight;

      // Alleen activeren als tekst langer is
      if (fullHeight > collapsedHeight + 2) {
        text.style.maxHeight = collapsedHeight + 'px';
        button.hidden = false;
      } else {
        return;
      }

      button.addEventListener('click', () => {
        const expanded = wrapper.classList.toggle('expanded');

        if (expanded) {
          text.style.maxHeight = fullHeight + 'px';
          button.textContent = 'Lees minder';
        } else {
          text.style.maxHeight = collapsedHeight + 'px';
          button.textContent = 'Lees meer';
        }

        button.setAttribute('aria-expanded', expanded);
      });
    });
});
